document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});


(function () {
  const currentUrl = window.location.href;

  document.querySelectorAll("a.yv-product-img").forEach((element) => {
    element.addEventListener('click', (e) => {

      //var carousel_id = "";
      //document.querySelectorAll("div.yv-collection-product-grid yv-tabbed-collection-filter-items product-grid-carousel flickity-enabled is-draggable").forEach((element) => {
      //    var id = e.currentTarget.getAttribute('id');
      //    console.log("carousel_id: " + carousel_id);
      //});

      var id = e.currentTarget.getAttribute('data-product-id');
      gtag('event', 'screen_view', {
        'app_name': id,
        'screen_name': currentUrl
      });
      console.log("ID cliccato: " + id);
      console.log("Pagina corrente: " + currentUrl);
    });
  });
})();

  

  


function showTooltip() {
    let visibility = document.getElementById('tooltip').style.visibility;
    if ( visibility == "hidden" ) {
    document.getElementById("tooltip").style.visibility = "visible";
    } else {
    document.getElementById("tooltip").style.visibility = "hidden";
    };
  };

$(document).ready(function() {
    $("scalapay-widget").css("all", "");
    $("scalapay-widget").css("font-family", "greycliff-cfregular");
    $("scalapay-widget").css("font-size", "12px");
    $("scalapay-widget").css("text-align", "center"); 
    $("scalapay-widget").css("margin-top", "20px"); 
    $("scalapay-widget").css("background", "#fff");
    $("sscalapay-widget").css("padding-top", "3px"); 
    $("scalapay-widget").css("border-radius", "8px");
});

function closeCookiePopUp() {
  var close  = document.getElementById("shopify-pc__banner");
  close.innerHTML = "<button id='shopify-pc__banner__btn-decline' class='shopify-pc__banner__btn-decline cookie-close' type='button'>[X]</button>"; 
}

function click2copy() {
  var copyText = "EXTRA5%";
  navigator.clipboard.writeText(copyText);
  var tooltip = document.getElementById("myTooltip");
  tooltip.innerHTML = "Copiato: " + copyText;
}

function outC2C() {
  var tooltip = document.getElementById("c2cTooltip");
  tooltip.innerHTML = "Copia nel blocco note";
}

// CHANGES THE FONT COLOR WHEN HOVERING WHITE BUTTONS IN SLIDER AND COLLAGE COMPONENTS
document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.getElementsByClassName('button');
    const buttonBefore = document.querySelector('.button:before');

    Array.from(buttons).forEach(button => {
        button.addEventListener('mouseenter', () => {
            const beforeBgColor = window.getComputedStyle(button).color;
            const bgColor = window.getComputedStyle(button).backgroundColor;
          console.log("Colore di sfondo: ", bgColor);
          console.log("Colore di sfondo before: ", beforeBgColor);
            const oppositeColor = getOppositeColor(bgColor);
          console.log("Colore opposto: ", oppositeColor);
            button.style.color = oppositeColor;
          function getOppositeColor(rgb) {
        // Extract the RGB components
        console.log("Colore di sfondo before: ", beforeBgColor);
        const color = rgb.match(/\d+/g).map(Number);
        const r = color[0];
        const g = color[1];
        const b = color[2];

        // Calculate the opposite color
      if ( beforeBgColor == "rgb(255, 255, 255)") {
        var oppositeR = 57;
        var oppositeG = 10;
        var oppositeB = 10;
      } else {
        var oppositeR = 255;
        var oppositeG = 255;
        var oppositeB = 255;
      }
        

        return `rgb(${oppositeR}, ${oppositeG}, ${oppositeB})`;
    }
        });

        button.addEventListener('mouseleave', () => {
            button.style.color = ''; // Reset to original color
        });
      
    });

    
});

/* *******************************************
   *   PROGRAMMAZIONE INIZIO TIMER HP & PDP  *
   ******************************************* */
    var dealSection = function (e) {
      var t;
      const MS_MIN = 60000,
        MS_HR = 3600000,
        MS_DAY = 24 * MS_HR;

      (countdown = function (selector) {
        const o = document.querySelector(selector);
        if (!o) return;

        clearInterval(t);

        const endInput = o.querySelector(".dealDate"); // data di fine (section.settings.date)
        const startInput = o.querySelector(".startDate"); // nuova data di inizio (section.settings.start_date)
        if (!endInput) return;

        // Parsing date nel formato DD/MM/YYYY
        const parseDate = (val) => {
          const [dd, mm, yyyy] = val.split("/");
          return new Date(Number(yyyy), Number(mm) - 1, Number(dd), 0, 0, 0, 0).getTime();
        };

        const endTs = parseDate(endInput.value);
        const startTs = startInput && startInput.value ? parseDate(startInput.value) : null;

        const p = o.querySelector("#dDays"),
          y = o.querySelector("#dHours"),
          f = o.querySelector("#dMinutes"),
          v = o.querySelector("#dSeconds");

        t = setInterval(function () {
          const now = Date.now();
          const diff = endTs - now;

          // --- Logica di visibilità ---
          if (startTs && now < startTs) {
            // Prima della data di attivazione → nascondi
            o.style.display = "none";
          } else if (diff <= 0) {
            // Dopo la data di fine → nascondi
            if (o.getAttribute("data-hide-section") == "true") o.style.display = "none";
            clearInterval(t);
          } else {
            // Tra start_date e end_date → mostra
            o.style.removeProperty("display");
          }

          // Aggiornamento countdown (se esistono gli elementi)
          if (p && y && f && v) {
            const days = Math.floor(Math.max(diff, 0) / MS_DAY);
            p.innerText = pad2(days);
            y.innerText = pad2(Math.floor((Math.max(diff, 0) % MS_DAY) / MS_HR));
            f.innerText = pad2(Math.floor((Math.max(diff, 0) % MS_HR) / MS_MIN));
            v.innerText = pad2(Math.floor((Math.max(diff, 0) % MS_MIN) / 1000));
          }
        }, 1000);
      })("#" + e);
    };